import { useMutation, UseMutationResult } from 'react-query'
import { errorAlert, loadingAlert, successAlert } from '../../../utils/alert'
import { localConfig } from '../../../Configs/localConfig'
import { api } from '../../api'

export type Ativos = {
  cod_ativo: number
  concentracao: string
}

type Doses = {
  cod_cultura: number
  dose: number
}

type Propriedades = {
  calda: number[]
  planta: number[]
}

interface PropsAdjuvantes {
  ativos: Ativos[]
  doses: Doses[]
  propriedades_calda: number[]
  propriedades_planta: number[]
  acao_ph_calda: number
  cod_categoria_produto: number
  cod_fabricante: number
  cod_medida_aplicacao: number
  cod_medida_composicao: number
  propriedades: Propriedades
  nome: string
  descricao: string
  refetch: Function
}

export const usePostAdjuvante = (): {
  carregando_salvar_adjuvante: boolean
  mutate_adjuvante: (params: PropsAdjuvantes) => void
  isSuccess_adjuvante: boolean
} => {

  const { conta, codCliente } = localConfig();
  const isCliente = localStorage.getItem('cod-cliente') !== '' && localStorage.getItem('cod-cliente') !== undefined

  const mutation: UseMutationResult<Response, Error, PropsAdjuvantes> = useMutation(
    async (params: PropsAdjuvantes) => {
      const {
        nome,
        descricao,
        ativos,
        doses,
        propriedades,
        propriedades_calda,
        propriedades_planta,
        cod_categoria_produto,
        cod_fabricante,
        cod_medida_aplicacao,
        cod_medida_composicao,
        acao_ph_calda,
        refetch
      } = params

      loadingAlert({ msg: 'Salvando...', id: 'loading' })
      const paramCliente = isCliente && codCliente ? `&codCliente=${codCliente}` : ''
      return api
        .post(`/recomendacao/adjuvante?codConta=${conta}${paramCliente}`, {
          nome,
          descricao,
          ativos,
          doses,
          propriedades,
          propriedades_calda,
          propriedades_planta,
          cod_categoria_produto,
          cod_fabricante,
          cod_medida_aplicacao,
          cod_medida_composicao,
          acao_ph_calda,
        })
        .then((response: any) => {
          successAlert('Adjuvante cadastrado com sucesso!', 5000, 'loading')
          refetch?.()
          return response
        })
        .catch((error: any) => {
          if (error?.response?.data?.error[0]?.msg) {
            error.response.data.error.forEach((data) => {
              errorAlert(data?.msg[0] ?? 'Falha ao salvar fertilizante!', 5000, 'loading')
            })
          } else {
            errorAlert(
              error.response.data.error ?? 'Falha ao salvar fertilizante!',
              5000,
              'loading'
            )
          }

          throw error
        })
    }
  )

  return {
    carregando_salvar_adjuvante: mutation.isLoading,
    mutate_adjuvante: mutation.mutate,
    isSuccess_adjuvante: mutation.isSuccess,
  }
}

export const usePutAdjuvante = (cod: number): {
  carregando_salvar_adjuvante_editado: boolean
  mutate_adjuvante_editado: (params: PropsAdjuvantes) => void
  isSuccess_adjuvante_editado: boolean
} => {

  const { conta, codCliente } = localConfig();
  const isCliente = localStorage.getItem('cod-cliente') !== '' && localStorage.getItem('cod-cliente') !== undefined

  const mutation: UseMutationResult<Response, Error, PropsAdjuvantes> = useMutation(
    async (params: PropsAdjuvantes) => {
      const {
        nome,
        descricao,
        ativos,
        doses,
        propriedades,
        propriedades_calda,
        propriedades_planta,
        cod_categoria_produto,
        cod_fabricante,
        cod_medida_aplicacao,
        cod_medida_composicao,
        acao_ph_calda,
        refetch
      } = params

      loadingAlert({ msg: 'Salvando...', id: 'loading' })

      const paramCliente = isCliente && codCliente ? `&codCliente=${codCliente}` : ''

      return api
        .post(`/recomendacao/adjuvante/${cod}?codConta=${conta}${paramCliente}`, {
          nome,
          descricao,
          ativos,
          doses,
          propriedades,
          propriedades_calda,
          propriedades_planta,
          cod_categoria_produto,
          cod_fabricante,
          cod_medida_aplicacao,
          cod_medida_composicao,
          acao_ph_calda,
        })
        .then((response: any) => {
          successAlert('Adjuvante cadastrado com sucesso!', 5000, 'loading')
          refetch?.()
          return response
        })
        .catch((error: any) => {
          if (error?.response?.data?.error[0]?.msg) {
            error.response.data.error.forEach((data) => {
              errorAlert(data?.msg[0] ?? 'Falha ao salvar fertilizante!', 5000, 'loading')
            })
          } else {
            errorAlert(
              error.response.data.error ?? 'Falha ao salvar fertilizante!',
              5000,
              'loading'
            )
          }

          throw error
        })
    }
  )

  return {
    carregando_salvar_adjuvante_editado: mutation.isLoading,
    mutate_adjuvante_editado: mutation.mutate,
    isSuccess_adjuvante_editado: mutation.isSuccess,
  }
}